import './App.css';
import Nav from './components/Nav';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Home from './components/Home';
import Skills from './components/Skills';
import Photography from './components/Photography';
import Contact from './components/Contact';
import Services from './components/Services';
import About from './components/About';
import AboutMe from './components/Pages/AboutMe';
import ServicesPage from './components/Pages/ServicesPage';
import MySkills from './components/Pages/MySkills';
import ContactMe from './components/Pages/ContactMe';



function App() {
  return (
    <Router>
      <Nav />
      <Switch>
        <Route exact path="/">
          <Home/>
        </Route>
        <Route path="/home">
          <Home/>
          </Route>
          <Route path="/services">
            <ServicesPage/>
          </Route>
          <Route path="/about">
            <AboutMe/>
          </Route>
          <Route path="/skills">
            <MySkills/>
          </Route>
          <Route path="/photography">
            <Photography/>
          </Route>
          <Route path="/contact">
            <ContactMe/>
          </Route>
      </Switch>
      {/* <Footer/> */}


    </Router>
  );
}

export default App;
